/*
 * @Author: cc
 * @Date: 2021-01-13 19:23:07
 * @LastEditTime: 2021-01-20 11:58:04
 * @LastEditors: cc
 * @FilePath: \MCN_new\app\main\submissionManage\personalLibrary\editImage\editImage_router.js
 * @Description: 
 */
/**
 * pgc视频路由
 */
'use strict';
angular.module('editImageRouterModule', []).config([
    '$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('editImage', {
            url: '/editImage?id&type',
            views: {
                '': {
                    template: '<div class="view_head" ui-view="header"></div>' + '<div class="view_body">' + '<div class="" ui-view="main"></div>' + '</div>'
                },
                'header@editImage': {
                    templateUrl: 'header/headerDetails_tpl.html',
                    controller: 'webHeaderCtrl'
                },
                'main@editImage': {
                    templateUrl: './main/submissionManage/personalLibrary/editImage/editImage.html',
                    controller: 'editImageCtrl'
                }
            }
        });
    }
]);
